import SignupFlowTemplate from '@ordermentum/ui-shared/templates/SignupFlowTemplate';
import React, { useState } from 'react';
import useSWR from 'swr';
import { fetcher } from '@ordermentum/ui-shared/swr/fetchers';
import { SupplierDirectoryType } from '@ordermentum/ui-types';
import SignInForm from './components/SignInForm';
import SignUpForm from './components/SignUpForm';
import VenueForm from './components/VenueForm';
import VerifyEmail from './components/VerifyEmailPage';

export type Pages = 'signIn' | 'signUp' | 'venue' | 'verifyEmail';

export type Account = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

export type Venue = {
  tradingName: string;
  legalName: string;
  abn: string;
  venuePhone: string;
  street: string;
  suburb: string;
  postcode: string;
  state: string;
  country: string;
};

export type SignUpValues = Account & Venue;

interface Props {
  supplierId: string;
  retailerId: string;
  page?: Pages;
}

const AccountPage = (props: Props) => {
  const { supplierId, retailerId } = props;
  const [page, setPage] = useState<Pages>(props.page || 'signIn');
  const [signUpValues, setSignUpValues] = useState<SignUpValues>();

  const { data: supplier, error } = useSWR<SupplierDirectoryType>(
    `/v1/suppliers/directory/${supplierId}`,
    fetcher()
  );

  if (error) {
    return <></>;
  }

  const Pages = {
    signIn: SignInForm,
    signUp: SignUpForm,
    venue: VenueForm,
    verifyEmail: VerifyEmail,
  }[page];

  return (
    <SignupFlowTemplate
      sticky
      params={{ supplierId, retailerId }}
      supplier={supplier}
      showSupplierInformation={page === 'signIn'}
    >
      <Pages
        onPageChange={formPage => {
          setPage(formPage);
        }}
        onFormValueChange={formValues => {
          if (formValues) {
            setSignUpValues(formValues);
          }
        }}
        formValues={signUpValues}
        supplier={supplier}
      />
    </SignupFlowTemplate>
  );
};

export default AccountPage;
